module.exports = __webpack_public_path__ + "img/Key functions.a0dadc6f.png";